"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class AgentEnvironment {
    constructor(agentEnvironmentId, presence, storage, contributions) {
        this._id = agentEnvironmentId;
        this._presence = presence;
        this._storage = storage;
        this._contributions = contributions;
    }
    get id() {
        return this._id;
    }
    subscribeToPresence(type, handlers) {
        this._presence.subscribeToPresence(type, handlers);
    }
    unsubscribeFromPresence(type) {
        this._presence.unsubscribeFromPresence(type);
    }
    getRemoteAgents() {
        return this._presence.getRemoteAgents();
    }
    writeToStorage(key, value, agent) {
        return this._storage.writeToStorage(key, value, agent);
    }
    getFromStorage(key, agent) {
        return this._storage.getFromStorage(key, agent);
    }
    getKeysFromStorage(agent) {
        return this._storage.getKeysFromStorage(agent);
    }
    removeFromStorage(key, agent) {
        return this._storage.removeFromStorage(key, agent);
    }
    removeAllFromStorage(agent) {
        return this._storage.removeAllFromStorage(agent);
    }
    subscribeToStorage(key, agent, handler) {
        this._storage.subscribeToStorage(key, agent, handler);
    }
    unsubscribeFromStorage(key, agent) {
        this._storage.unsubscribeFromStorage(key, agent);
    }
    unsubscribeFromContributions(type, agent) {
        this._contributions.unsubscribeFromContributions(type, agent);
    }
    makeContribution(contribution, agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._contributions.makeContribution(contribution, agentId);
        });
    }
    getContributions(type, agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._contributions.getContributions(type, agentId);
        });
    }
    getTypesFromContributions(agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._contributions.getTypesFromContributions(agentId);
        });
    }
    removeContribution(contribution) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._contributions.removeContribution(contribution);
        });
    }
    removeAllFromContributions(agent) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._contributions.removeAllFromContributions(agent);
        });
    }
    subscribeToContributions(type, handler, agentId) {
        this._contributions.subscribeToContributions(type, handler, agentId);
    }
}
exports.default = AgentEnvironment;
//# sourceMappingURL=AgentEnvironment.js.map